/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum IUserInvestorInfoScore {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
}

export enum IContentType {
  RegisterContent = 'register-content',
  FaqDialog = 'faq-dialog',
  GdprDialog = 'gdpr-dialog',
  DialogPrivacyGdpr = 'dialog-privacy-gdpr',
  DialogPrivacyMarketing = 'dialog-privacy-marketing',
  DialogPrivacyBiometry = 'dialog-privacy-biometry',
}

export enum IOnboardingStep {
  EmailRegistration = 'emailRegistration',
  PhoneVerification = 'phoneVerification',
  IdentityVerification = 'identityVerification',
  IdentityVerificationConfirmed = 'identityVerificationConfirmed',
  CompanyFormCompletion = 'companyFormCompletion',
  CompanyFormAdminConfirmation = 'companyFormAdminConfirmation',
  QuestionnaireCompletion = 'questionnaireCompletion',
  ContractSignature = 'contractSignature',
}

export enum IWalletType {
  CSOB = 'CSOB',
}

export enum IWalletCategory {
  Investor = 'investor',
  Project = 'project',
  Platform = 'platform',
}

export enum IAmbassadorType {
  Senior = 'senior',
  Solo = 'solo',
}

export enum IInvestorInfoType {
  Sophisticated = 'sophisticated',
  Unsophisticated = 'unsophisticated',
  Unknown = 'unknown',
}

export enum IVerificationStatus {
  Started = 'started',
  Submitted = 'submitted',
  Approved = 'approved',
  Declined = 'declined',
  ResubmissionRequested = 'resubmission_requested',
  Manual = 'manual',
  Underage = 'underage',
  ExpiredId = 'expired_id',
  ReverificationMismatch = 'reverification_mismatch',
}

export enum IIbanStatus {
  Verified = 'verified',
  Unverified = 'unverified',
  Cancelled = 'cancelled',
  Deleted = 'deleted',
}

/** Účel kódu (interný verifyPhone tu nie je povolený) */
export enum ITwoFAGeneratePurpose {
  Login = 'login',
  AddBankAccount = 'addBankAccount',
  OrderInvestment = 'orderInvestment',
  ChangePhoneNumber = 'changePhoneNumber',
  VerifyPhone = 'verifyPhone',
}

export enum IUserNotificationType {
  RegistrationFinished = 'registration_finished',
  WithdrawalSuccess = 'withdrawal_success',
  OrderCreated = 'order_created',
  AdminCompanyConfirmation = 'admin_company_confirmation',
  FeeNotice = 'fee_notice',
}

export enum IUserNotificationCategory {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  FeeNotice = 'fee_notice',
}

export interface IUnauthorizedResponse {
  /** @example 401 */
  statusCode: number
  /** @example "Unauthorized" */
  error: string
}

export interface IForbiddenResponse {
  /** @example 403 */
  statusCode: number
  /** @example "Forbidden" */
  error: string
}

export interface ISettingGetPhonePrefixesOkResponse {
  /** Optional success message */
  message?: string
  items: string[]
}

export interface ICountrySchema {
  _id: string
  /** @format date-time */
  createdAt: string
  createdBy: string
  /** @format date-time */
  modifiedAt: string
  modifiedBy: string
  name: string
  native: string
  orders: number
  phone: string
  publishedIntl: boolean
  published: boolean
}

export interface ISettingGetCountriesOkResponse {
  /** Optional success message */
  message?: string
  items: ICountrySchema[]
}

export interface IInvestmentDateFilters {
  latestPaymentYears: number[]
  investmentYears: number[]
}

export interface ISettingGetInvestmentDateFiltersOkResponse {
  /** Optional success message */
  message?: string
  data: IInvestmentDateFilters
}

export interface IAffiliateItem {
  _id: string
  userName: string
  userSign: string
  userActive: boolean
  bonusAffiliate: number
  /** @format date-time */
  createdAt: string
}

export interface ISettingGetAffiliateListOkResponse {
  /** Optional success message */
  message?: string
  items: IAffiliateItem[]
}

export interface ICompanyInfoDto {
  companyName: string
  ico: string
  bankName: string
  iban: string
  swift: string
}

export interface ISettingGetCompanyInfoOkResponse {
  /** Optional success message */
  message?: string
  data: ICompanyInfoDto
}

export interface IFeeImmunityCampaignDto {
  campaigns: string[]
  /** @format date-time */
  validUntil?: string
}

export interface IRevenueFeeSettingDto {
  enabled: boolean
  fee: number
  /** @format date-time */
  validFrom?: string
  feeImmunityCampaigns: IFeeImmunityCampaignDto[]
}

export interface ISettingGetRevenueFeeOkResponse {
  /** Optional success message */
  message?: string
  data: IRevenueFeeSettingDto
}

export interface IBoosterProjectSettingDto {
  isAvailable: boolean
}

export interface ISettingGetBoosterProjectSettingOkResponse {
  /** Optional success message */
  message?: string
  data: IBoosterProjectSettingDto
}

export interface IInvestmentReservationWithdrawalSettingDto {
  enabled: boolean
  withdrawWindowDurationDays: number
}

export interface ISettingGetInvestmentReservationWithdrawalSettingOkResponse {
  /** Optional success message */
  message?: string
  data: IInvestmentReservationWithdrawalSettingDto
}

export interface ISetMarketingSettingsRequest {
  /** GDPR marketing consent zapnutý/vypnutý */
  isEnabled: boolean
}

export interface ISetMarketingSettingsOkResponse {
  /** Optional success message */
  message?: string
}

export interface IBadRequestResponse {
  /** @example 400 */
  statusCode: number
  /** @example "Bad Request" */
  error: string
}

export interface ISetSecuritySettingsRequest {
  /** Login 2FA zapnuté/vypnuté */
  isTwoFaEnabled: boolean
}

export interface ISetSecuritySettingsOkResponse {
  /** Optional success message */
  message?: string
}

export interface IChangePasswordRequest {
  oldPassword: string
  newPassword: string
  confirmPassword: string
}

export interface IChangePasswordOkResponse {
  /** Optional success message */
  message?: string
}

export interface IUserVerifyPhoneNumberVerifyRequest {
  number: string
  code: string
  gdpr?: boolean
  marketing?: boolean
}

export interface IOnboardingOkResponse {
  /** Optional success message */
  message?: string
}

export interface IUserNotificationSchema {
  _id: string
  category: IUserNotificationCategory
  /** @format date-time */
  createdAt: string
  /** @format date-time */
  updatedAt?: string
  read: boolean
  type: IUserNotificationType
  userId: string
  data: Record<string, any> | null
}

export interface INotificationListOkResponse {
  /** Optional success message */
  message?: string
  items: IUserNotificationSchema[]
}

export interface INotificationMarkAsReadRequest {
  notificationId: string
}

export interface INotificationMarkAsReadOkResponse {
  /** Optional success message */
  message?: string
}

export interface IGenerateTwoFaCodeRequest {
  /** Účel kódu (interný verifyPhone tu nie je povolený) */
  purpose: ITwoFAGeneratePurpose
  /** Purpose-špecifický kontext — addBankAccount: {iban}; orderInvestment: {projectId, walletId, principalFixed} */
  data?: object
}

export interface IGenerateTwoFaCodeOkResponse {
  /** Optional success message */
  message?: string
  /**
   * Expirácia kódu (teraz + 3 min)
   * @format date-time
   */
  expiresAt: string
  /** Určuje, či bol kód znovu použitý */
  reused: boolean
}

export interface IUserProfileKYCSchema {
  politika: boolean
  sankcie: boolean
}

export interface IAccountInfoProfileAddress {
  street: string
  number: string
  city: string
  zip: string
  state: string
}

export interface IAccountInfoProfileCompany {
  id: string
  vat: string
  vatNumber: string
  name: string
  streetAddress: string
  isSoleTrader: boolean
  city?: string
  zipCode?: string
  country?: string
}

export interface IAccountInfoProfileBankAccount {
  iban: string
  statusId: IIbanStatus
}

export interface IAccountInfoProfileIdentity {
  verificationStatus?: IVerificationStatus
  isUnderage: boolean
}

export interface IAccountInfoProfileInvestorInfo {
  type: IInvestorInfoType
}

export interface IAccountInfoProfileGdpr {
  marketingType: string
}

export interface IAccountInfoProfileAmbassador {
  type: IAmbassadorType
}

export interface IAccountInfoProfileMyAmbassador {
  ambassadorId: string
}

export interface IAccountInfoProfile {
  email: string
  sign: string
  firstname?: string
  lastname?: string
  fullname?: string
  phone?: string
  isCompany?: boolean
  adminVerifiedCompany?: boolean
  userConfirmedCompanyInfo?: boolean
  tokenAffil?: string
  kyc?: IUserProfileKYCSchema
  address?: IAccountInfoProfileAddress
  company?: IAccountInfoProfileCompany
  bankAccounts?: IAccountInfoProfileBankAccount[]
  identity?: IAccountInfoProfileIdentity
  investorInfo?: IAccountInfoProfileInvestorInfo
  gdpr?: IAccountInfoProfileGdpr
  ambassador?: IAccountInfoProfileAmbassador
  myAmbassador?: IAccountInfoProfileMyAmbassador
}

export interface IAccountInfoMeta {
  authType: 'google' | 'email'
  login2FAEnabled: boolean
  hasPassword: boolean
  tags: string[]
  activeCouponType: 'ab_fix' | 'ab_percentual' | null
}

export interface IAccountInfoWalletFunds {
  available: number
}

export interface IAccountInfoWalletAggregates {
  disponibleFunds: number
}

export interface IAccountInfoWalletCsob {
  variableSymbol: string
}

export interface IAccountInfoWallet {
  _id: string
  category: IWalletCategory
  type: IWalletType
  funds?: IAccountInfoWalletFunds
  aggregates?: IAccountInfoWalletAggregates
  csob?: IAccountInfoWalletCsob
}

export interface IAccountInfoOnboarding {
  isUserApproved: boolean
  currentRequiredStep: IOnboardingStep | null
}

export interface IUserInfoDto {
  _id: string
  profile: IAccountInfoProfile
  meta: IAccountInfoMeta
  wallets: IAccountInfoWallet[]
  investorWallet?: IAccountInfoWallet
  hasVerifiedEmail: boolean
  hasRevenueFeeImmunity: boolean
  isWithdrawAndAddFundsEnabled: boolean
  hasExpiredInvestorAnalysis: boolean
  hasExpiredIdentityDocument: boolean
  onboarding: IAccountInfoOnboarding
}

export interface IAccountInfoOkResponse {
  /** Optional success message */
  message?: string
  user: IUserInfoDto
}

export interface IContentTranslation {
  sk?: string
  cz?: string
  en?: string
  es?: string
  fr?: string
  ru?: string
}

export interface IContentSchema {
  _id: string
  typeId: IContentType
  published?: boolean
  content: IContentTranslation
  priority?: number
}

export interface IGetContentOkResponse {
  /** Optional success message */
  message?: string
  data?: IContentSchema | null
}

export interface IUserVerifyPhoneNumberStartRequest {
  number: string
}

export interface IUserVerifyPhoneNumberStartOkResponse {
  /** Optional success message */
  message?: string
  /** @format date-time */
  expiresAt: string
}

export interface IUserSetIsCompanyRequest {
  isCompany: boolean
}

export interface IUserCompanyData {
  name: string
  id: string
  vat: string
  vatNumber: string
  isSoleTrader: boolean
  streetAddress: string
  country?: string
  zipCode?: string
  city?: string
}

export interface IUserUpdateCompanyDataRequest {
  company: IUserCompanyData
  /** @default false */
  userConfirmedCompanyInfo?: boolean
}

export interface IUserSetBrokerCodeRequest {
  brokerCode: string
  brokerCodeRememberedAt: string
}

export interface IIdentityConfirmKyc {
  politika: boolean
  sankcie: boolean
}

export interface IUserIdentityConfirmRequest {
  kyc: IIdentityConfirmKyc
}

export interface IInvestorAnalysisSophisticatedAnswersV1 {
  highIncomeOrLargePortfolio: boolean
  experiencedInFinanceOrExecutiveRole: boolean
  experienceInLargeCompanies: boolean
  averaged10LargeTransactionsQuarterlyLastYear: boolean
}

export interface IInvestorAnalysisUnsophisticatedAnswersV1 {
  investmentExperience: 'experienced' | 'intermediate' | 'novice'
  /** Zaškrtnuté nástroje */
  investmentInstruments?: (
    | 'bonds'
    | 'stocks'
    | 'investmentFunds'
    | 'realEstate'
    | 'cryptocurrencies'
    | 'startups'
    | 'crowdfunding'
  )[]
  collectiveFinancingResults?:
    | 'investmentAppreciated'
    | 'investedMoreThanEarned'
    | 'noResultsYet'
    | 'noExperience'
  pastInvestmentAmount?:
    | 'lessThanSmallAmount'
    | 'lessThanMediumAmount'
    | 'lessThanLargeAmount'
    | 'moreThanLargeAmount'
  investmentFrequency?:
    | 'oncePerYear'
    | 'lessThanThreeTimesPerYear'
    | 'lessThanTenTimesPerYear'
    | 'moreThanTenTimesPerYear'
  financialStability:
    | 'lowCapitalPreferLowLosses'
    | 'moderateFinancialStabilityCanBearLimitedLosses'
    | 'highFinancialStabilityWillingToAcceptSignificantLosses'
  riskAttitude:
    | 'minimizeRiskPreferSteadyReturns'
    | 'willingToAcceptHighRiskForPotentialHigherReturns'
    | 'openToExtremeRiskStrategiesForHighReturns'
  investmentGoal:
    | 'protectAgainstInflationMinimalRisk'
    | 'growAssetsWithModerateMarketRisk'
    | 'significantlyGrowAssetsEvenAtTheCostOfLoss'
  investmentDuration: 'shortterm' | 'midterm' | 'longterm'
  educationLevel:
    | 'basicEducation'
    | 'vocationalEducation'
    | 'higherEducation'
    | 'professionalQualification'
  /** @min 0 */
  annualNetIncome: number
  /** @min 0 */
  assetsValue: number
  /** @min 0 */
  annualCommitmentsAmount: number
}

export interface IInvestorAnalysisAnswersSchemaV1 {
  initial: boolean | null
  sophisticated: IInvestorAnalysisSophisticatedAnswersV1 | null
  unsophisticated: IInvestorAnalysisUnsophisticatedAnswersV1 | null
}

export interface IFinishInvestorAnalysisRequest {
  /**
   * Verzia dotazníka (FE `VITE_ONBOARDING_INVESTOR_ANALYSIS_VERSION`)
   * @example "1"
   */
  version: '1'
  /** Odpovede dotazníka; tvar podľa `version` */
  answers: IInvestorAnalysisAnswersSchemaV1
  /** User potvrdil obrazovku „Vysoké investičné riziko“; povinné pri skóre F */
  riskWarningConfirmed?: boolean
}

export interface IEvaluateInvestorAnalysisRequest {
  /**
   * Verzia dotazníka (FE `VITE_ONBOARDING_INVESTOR_ANALYSIS_VERSION`)
   * @example "1"
   */
  version: '1'
  /** Odpovede dotazníka; tvar podľa `version` */
  answers: IInvestorAnalysisAnswersSchemaV1
}

export interface IEvaluateInvestorAnalysisOkResponse {
  /** Optional success message */
  message?: string
  isSophisticated: boolean
  score: IUserInvestorInfoScore | null
}

export interface IInvestorAnalysisQuestionLabelSchema {
  label: string
}

export interface IInvestorAnalysisAnswerSchema {
  label: string
  score?: number
}

export interface IInvestorAnalysisYesNoAnswersSchema {
  true: IInvestorAnalysisAnswerSchema
  false: IInvestorAnalysisAnswerSchema
}

export interface IInvestorAnalysisYesNoQuestionDefinitionSchema {
  question: IInvestorAnalysisQuestionLabelSchema
  answers: IInvestorAnalysisYesNoAnswersSchema
}

export interface IInvestorAnalysisSophisticatedDefinitionSchema {
  highIncomeOrLargePortfolio: IInvestorAnalysisYesNoQuestionDefinitionSchema
  experiencedInFinanceOrExecutiveRole: IInvestorAnalysisYesNoQuestionDefinitionSchema
  experienceInLargeCompanies: IInvestorAnalysisYesNoQuestionDefinitionSchema
  averaged10LargeTransactionsQuarterlyLastYear: IInvestorAnalysisYesNoQuestionDefinitionSchema
}

export interface IInvestorAnalysisChoiceQuestionDefinitionSchema {
  question: IInvestorAnalysisQuestionLabelSchema
  /** kľúč možnosti → { label, score } */
  answers: Record<string, IInvestorAnalysisAnswerSchema>
}

export interface IInvestorAnalysisAmountQuestionDefinitionSchema {
  question: IInvestorAnalysisQuestionLabelSchema
}

export interface IInvestorAnalysisUnsophisticatedDefinitionSchema {
  investmentExperience: IInvestorAnalysisChoiceQuestionDefinitionSchema
  investmentInstruments: IInvestorAnalysisChoiceQuestionDefinitionSchema
  collectiveFinancingResults: IInvestorAnalysisChoiceQuestionDefinitionSchema
  pastInvestmentAmount: IInvestorAnalysisChoiceQuestionDefinitionSchema
  investmentFrequency: IInvestorAnalysisChoiceQuestionDefinitionSchema
  financialStability: IInvestorAnalysisChoiceQuestionDefinitionSchema
  riskAttitude: IInvestorAnalysisChoiceQuestionDefinitionSchema
  investmentGoal: IInvestorAnalysisChoiceQuestionDefinitionSchema
  investmentDuration: IInvestorAnalysisChoiceQuestionDefinitionSchema
  educationLevel: IInvestorAnalysisChoiceQuestionDefinitionSchema
  annualNetIncome: IInvestorAnalysisAmountQuestionDefinitionSchema
  assetsValue: IInvestorAnalysisAmountQuestionDefinitionSchema
  annualCommitmentsAmount: IInvestorAnalysisAmountQuestionDefinitionSchema
}

export interface IInvestorAnalysisDefinitionSchemaV1 {
  initial: IInvestorAnalysisYesNoQuestionDefinitionSchema
  sophisticated: IInvestorAnalysisSophisticatedDefinitionSchema
  unsophisticated: IInvestorAnalysisUnsophisticatedDefinitionSchema
}

export interface IGetInvestorAnalysisDefinitionOkResponse {
  /** Optional success message */
  message?: string
  version: '1'
  definition: IInvestorAnalysisDefinitionSchemaV1
}

export interface IGetInvestorAnalysisResultOkResponse {
  /** Optional success message */
  message?: string
  type: IInvestorInfoType
  score: IUserInvestorInfoScore | null
  nettoAssets: number | null
  riskTolerance: number | null
}

export interface IAgreementPreviewItem {
  sign?: string
  header: string
  title: string
  content: string
  content2: string
}

export interface IAgreementPreview {
  sk: IAgreementPreviewItem
  lang: IAgreementPreviewItem
}

export interface IGetMainAgreementOkResponse {
  /** Optional success message */
  message?: string
  agreementPreview: IAgreementPreview
}

export interface IRegisterRequest {
  /** @format email */
  email: string
  /** Min 8 znakov, aspoň jedno malé + veľké písmeno + číslica (MEDIUM strength). */
  password: string
  lang: string
  /** GDPR súhlas musí byť true. */
  gdpr: boolean
  marketing: boolean
  /** @default "" */
  bonusCode?: string
  tokenAffilRecommender?: string
  ambassadorCode?: string
  turnstileToken?: string
  ambassador?: boolean
}

export interface IAuthentication {
  /** Resume token */
  token: string
  /** Expirácia (ms timestamp) */
  expiration: number
}

export interface IRegisterOkResponse {
  auth: IAuthentication
}

export interface ILoginRequest {
  /** @format email */
  email: string
  password: string
}

export interface ILoginOkResponse {
  twoFactorRequired: boolean
  /** 2FA vetva */
  sessionId?: string
  /**
   * 2FA vetva
   * @format date-time
   */
  twoFaCodeExpiresAt?: string
  auth?: IAuthentication
}

export interface ITwoFaVerifyRequest {
  sessionId: string
  code: string
}

export interface ITwoFaVerifyOkResponse {
  auth: IAuthentication
}

export interface IGoogleLoginRequest {
  code: string
  redirectUri?: string
  ambassadorCode?: string
}

export interface IGoogleLoginOkResponse {
  twoFactorRequired: boolean
  auth: IAuthentication
}

export interface ICheckOkResponse {
  isLoggedIn: boolean
}

export interface IForgotPasswordRequest {
  /** @format email */
  email: string
}

export interface IForgotPasswordOkResponse {
  /** Optional success message */
  message?: string
}

export interface IResetPasswordRequest {
  token: string
  password: string
}

export interface IResetPasswordOkResponse {
  auth: IAuthentication
}

export interface IVerifyEmailRequest {
  verifyToken: string
}

export interface IVerifyEmailOkResponse {
  /** Optional success message */
  message?: string
}

export interface IResendVerifyEmailTokenOkResponse {
  /** Optional success message */
  message?: string
}

export interface IOtpLoginRequest {
  /** Zašifrovaný user OTP token (hex: IV + ciphertext) */
  otpParam: string
}

export interface IOtpLoginOkResponse {
  /** Optional success message */
  message?: string
  auth: IOtpAuthentication
}

export interface IOtpAuthentication {
  /** Resume token */
  token: string
  /** Expirácia (ms timestamp) */
  expiration: number
  /**
   * Redirect URL
   * @example "https://example.com"
   */
  redirectUrl: string
}

export interface ISendOtpLoginLinkRequestDto {
  /**
   * Whether to send the OTP to the phone number
   * @example true
   */
  gdpr?: boolean
  /**
   * Whether to send the OTP to the phone number
   * @example true
   */
  marketing?: boolean
  /**
   * The phone number to verify
   * @example "+421912345678"
   */
  number?: string
  /**
   * The URL to redirect to after login
   * @example "https://example.com"
   */
  redirectUrl?: string
}

export interface IUserGenerateLoginOtpResponseDto {
  /** Optional success message */
  message?: string
  reused: boolean
  /** @format date-time */
  expiresAt: string
}

export type IErrorDetailsType = object

export interface IErrorObject {
  /** Error code */
  code: string
  /** Error message */
  error: string
}

export interface ICreateLogRequest {
  level: string
  message: string
  /** @default "" */
  subject?: string
  /** @default "" */
  event?: string
  /** @default {} */
  data?: object
}

export interface ICreateLogOkResponse {
  /** Optional success message */
  message?: string
}

export interface IDevSetIdentityStatusRequest {
  status:
    | 'submitted'
    | 'approved'
    | 'declined'
    | 'resubmission_requested'
    | 'underage'
    | 'expired_id'
    | 'reverification_mismatch'
  /** @example "2010-05-20" */
  birthDate?: string
}

export interface IDevSetIdentityStatusOkResponse {
  /** Optional success message */
  message?: string
}

export interface IDevSetAdminVerifiedCompanyOkResponse {
  /** Optional success message */
  message?: string
}

export interface IDevRunIdentityExpiryJobOkResponse {
  /** Optional success message */
  message?: string
}

export interface ISuccessResponse {
  /** Optional success message */
  message?: string
}

export interface IDevEmailVerificationCodeOkResponse {
  /** Optional success message */
  message?: string
  /** verify-email token (dev only) */
  code?: string
}

export interface IDevAddCreditOkResponse {
  /** Optional success message */
  message?: string
}

export interface IDevAddGiftOkResponse {
  /** Optional success message */
  message?: string
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = ''
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter(
      (key) => 'undefined' !== typeof query[key]
    )
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string'
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`
        )
        return formData
      }, new FormData())
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  }

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected createAbortSignal = (
    cancelToken: CancelToken
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { 'Content-Type': type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === 'undefined' || body === null
            ? null
            : payloadFormatter(body),
      }
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const responseToParse = responseFormat ? response.clone() : response
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch((e) => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data
    })
  }
}

/**
 * @title IIS User API
 * @version 1.0
 * @contact
 *
 * API for User
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  user = {
    /**
     * No description
     *
     * @tags User Settings
     * @name SettingsControllerGetPhonePrefixes
     * @summary Get phone prefixes
     * @request GET:/user/settings/phone-prefixes
     * @secure
     */
    settingsControllerGetPhonePrefixes: (params: RequestParams = {}) =>
      this.request<
        ISettingGetPhonePrefixesOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/settings/phone-prefixes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Settings
     * @name SettingsControllerGetCountries
     * @summary Get countries
     * @request GET:/user/settings/countries
     * @secure
     */
    settingsControllerGetCountries: (params: RequestParams = {}) =>
      this.request<
        ISettingGetCountriesOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/settings/countries`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Settings
     * @name SettingsControllerGetInvestmentDateFilters
     * @summary Get investment date filters
     * @request GET:/user/settings/investment-date-filters
     * @secure
     */
    settingsControllerGetInvestmentDateFilters: (params: RequestParams = {}) =>
      this.request<
        ISettingGetInvestmentDateFiltersOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/settings/investment-date-filters`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Settings
     * @name SettingsControllerGetAffiliates
     * @summary Get user affiliates
     * @request GET:/user/settings/affiliate
     * @secure
     */
    settingsControllerGetAffiliates: (params: RequestParams = {}) =>
      this.request<
        ISettingGetAffiliateListOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/settings/affiliate`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Settings
     * @name SettingsControllerGetCompanyInfo
     * @summary Get company info
     * @request GET:/user/settings/company-info
     * @secure
     */
    settingsControllerGetCompanyInfo: (params: RequestParams = {}) =>
      this.request<
        ISettingGetCompanyInfoOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/settings/company-info`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Settings
     * @name SettingsControllerGetRevenueFeeSetting
     * @summary Get revenue fee setting
     * @request GET:/user/settings/revenue-fee
     * @secure
     */
    settingsControllerGetRevenueFeeSetting: (params: RequestParams = {}) =>
      this.request<
        ISettingGetRevenueFeeOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/settings/revenue-fee`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Settings
     * @name SettingsControllerGetBoosterProject
     * @summary Get booster project setting
     * @request GET:/user/settings/booster-project
     * @secure
     */
    settingsControllerGetBoosterProject: (params: RequestParams = {}) =>
      this.request<
        ISettingGetBoosterProjectSettingOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/settings/booster-project`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Settings
     * @name SettingsControllerGetInvestmentReservationWithdrawal
     * @summary Get investment reservation withdrawal setting
     * @request GET:/user/settings/investment-reservation-withdrawal
     * @secure
     */
    settingsControllerGetInvestmentReservationWithdrawal: (
      params: RequestParams = {}
    ) =>
      this.request<
        ISettingGetInvestmentReservationWithdrawalSettingOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/settings/investment-reservation-withdrawal`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Settings
     * @name SettingsControllerSetMarketingSettings
     * @summary Set GDPR marketing consent
     * @request POST:/user/settings/marketing
     * @secure
     */
    settingsControllerSetMarketingSettings: (
      data: ISetMarketingSettingsRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        ISetMarketingSettingsOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/settings/marketing`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Settings
     * @name SettingsControllerSetSecuritySettings
     * @summary Set login 2FA (security settings)
     * @request POST:/user/settings/security
     * @secure
     */
    settingsControllerSetSecuritySettings: (
      data: ISetSecuritySettingsRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        ISetSecuritySettingsOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/settings/security`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Settings
     * @name SettingsControllerChangePassword
     * @summary Change the password (auth) — other sessions are logged out
     * @request POST:/user/settings/change-password
     * @secure
     */
    settingsControllerChangePassword: (
      data: IChangePasswordRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IChangePasswordOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/settings/change-password`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Settings
     * @name SettingsControllerChangePhoneNumberVerify
     * @summary Change phone number — verify SMS code and store the new number
     * @request POST:/user/settings/change-phone-number/verify
     * @secure
     */
    settingsControllerChangePhoneNumberVerify: (
      data: IUserVerifyPhoneNumberVerifyRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IOnboardingOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/settings/change-phone-number/verify`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Notifications
     * @name NotificationsControllerList
     * @summary Get user notifications
     * @request GET:/user/notifications
     * @secure
     */
    notificationsControllerList: (params: RequestParams = {}) =>
      this.request<
        INotificationListOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/notifications`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Notifications
     * @name NotificationsControllerMarkAsRead
     * @summary Mark notification as read
     * @request PATCH:/user/notifications/mark-as-read
     * @secure
     */
    notificationsControllerMarkAsRead: (
      data: INotificationMarkAsReadRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        INotificationMarkAsReadOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/notifications/mark-as-read`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User TwoFA
     * @name TwoFaCodeControllerGenerate
     * @summary Generate 2FA code (SMS) — reuses a still-valid pending code
     * @request POST:/user/twofa/generate
     * @secure
     */
    twoFaCodeControllerGenerate: (
      data: IGenerateTwoFaCodeRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IGenerateTwoFaCodeOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/twofa/generate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Account Info
     * @name AccountInfoControllerGetInfo
     * @summary Get user info (profile, meta, wallets, onboarding status)
     * @request GET:/user/account/info
     * @secure
     */
    accountInfoControllerGetInfo: (params: RequestParams = {}) =>
      this.request<
        IAccountInfoOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/account/info`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name ContentControllerGetContentById
     * @summary Get published CMS content by type (public)
     * @request GET:/user/content/{typeId}
     */
    contentControllerGetContentById: (
      typeId: IContentType,
      params: RequestParams = {}
    ) =>
      this.request<IGetContentOkResponse, IBadRequestResponse>({
        path: `/user/content/${typeId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerStartPhoneVerification
     * @summary Start phone number verification (send SMS code)
     * @request POST:/user/onboarding/verify-phone-number/start
     * @secure
     */
    onboardingControllerStartPhoneVerification: (
      data: IUserVerifyPhoneNumberStartRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IUserVerifyPhoneNumberStartOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/verify-phone-number/start`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerVerifyPhoneNumber
     * @summary Verify phone number SMS code + store GDPR/phone/country
     * @request POST:/user/onboarding/verify-phone-number/verify
     * @secure
     */
    onboardingControllerVerifyPhoneNumber: (
      data: IUserVerifyPhoneNumberVerifyRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IOnboardingOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/verify-phone-number/verify`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerSetIsCompany
     * @summary Set whether the investor is a company
     * @request POST:/user/onboarding/set-is-company
     * @secure
     */
    onboardingControllerSetIsCompany: (
      data: IUserSetIsCompanyRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IOnboardingOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/set-is-company`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerUpdateCompanyData
     * @summary Update company profile data
     * @request POST:/user/onboarding/update-company-data
     * @secure
     */
    onboardingControllerUpdateCompanyData: (
      data: IUserUpdateCompanyDataRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IOnboardingOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/update-company-data`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerSetBrokerCode
     * @summary Set broker code on the investor profile
     * @request POST:/user/onboarding/identity/set-broker-code
     * @secure
     */
    onboardingControllerSetBrokerCode: (
      data: IUserSetBrokerCodeRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IOnboardingOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/identity/set-broker-code`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerSetSubmittedIdentity
     * @summary Mark identity verification as submitted
     * @request POST:/user/onboarding/identity/submitted
     * @secure
     */
    onboardingControllerSetSubmittedIdentity: (params: RequestParams = {}) =>
      this.request<
        IOnboardingOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/identity/submitted`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerReverifyIdentity
     * @summary Restart identity verification
     * @request POST:/user/onboarding/identity/reverify
     * @secure
     */
    onboardingControllerReverifyIdentity: (params: RequestParams = {}) =>
      this.request<
        IOnboardingOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/identity/reverify`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerConfirmIdentity
     * @summary Confirm identity verification (KYC consents + lang/country)
     * @request POST:/user/onboarding/identity/confirm
     * @secure
     */
    onboardingControllerConfirmIdentity: (
      data: IUserIdentityConfirmRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IOnboardingOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/identity/confirm`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerResetInvestorAnalysis
     * @summary Reset the investor questionnaire
     * @request POST:/user/onboarding/reset-investor-analysis
     * @secure
     */
    onboardingControllerResetInvestorAnalysis: (params: RequestParams = {}) =>
      this.request<
        IOnboardingOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/reset-investor-analysis`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerFinishInvestorAnalysis
     * @summary Finish the investor questionnaire — API evaluates investor type and score
     * @request POST:/user/onboarding/finish-investor-analysis
     * @secure
     */
    onboardingControllerFinishInvestorAnalysis: (
      data: IFinishInvestorAnalysisRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IOnboardingOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/finish-investor-analysis`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerEvaluateInvestorAnalysis
     * @summary Evaluate the investor questionnaire in progress (sophisticated test, score); nothing is saved
     * @request POST:/user/onboarding/evaluate-investor-analysis
     * @secure
     */
    onboardingControllerEvaluateInvestorAnalysis: (
      data: IEvaluateInvestorAnalysisRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IEvaluateInvestorAnalysisOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/evaluate-investor-analysis`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerGetInvestorAnalysisDefinition
     * @summary Questions, answer options and points of the investor questionnaire version
     * @request GET:/user/onboarding/investor-analysis-definition
     * @secure
     */
    onboardingControllerGetInvestorAnalysisDefinition: (
      query: {
        /** @example "1" */
        version: '1'
      },
      params: RequestParams = {}
    ) =>
      this.request<
        IGetInvestorAnalysisDefinitionOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/investor-analysis-definition`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerGetInvestorAnalysisResult
     * @summary Result of the finished investor questionnaire (type, score, risk simulation)
     * @request GET:/user/onboarding/investor-analysis-result
     * @secure
     */
    onboardingControllerGetInvestorAnalysisResult: (
      params: RequestParams = {}
    ) =>
      this.request<
        IGetInvestorAnalysisResultOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/investor-analysis-result`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerFinishRegistration
     * @summary Finish registration — generate main+KYC agreement, approve user
     * @request POST:/user/onboarding/finish-registration
     * @secure
     */
    onboardingControllerFinishRegistration: (params: RequestParams = {}) =>
      this.request<
        IOnboardingOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/finish-registration`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name OnboardingControllerGetMainAgreement
     * @summary Preview of the main investor agreement (no onboarding gate)
     * @request GET:/user/onboarding/main-agreement
     * @secure
     */
    onboardingControllerGetMainAgreement: (params: RequestParams = {}) =>
      this.request<
        IGetMainAgreementOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/onboarding/main-agreement`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name AuthControllerRegister
     * @summary Register a new investor (email + password), auto-login resume token
     * @request POST:/user/auth/register
     */
    authControllerRegister: (
      data: IRegisterRequest,
      params: RequestParams = {}
    ) =>
      this.request<IRegisterOkResponse, IBadRequestResponse>({
        path: `/user/auth/register`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name AuthControllerLogin
     * @summary Login (email + password) — resume token, alebo 2FA výzva
     * @request POST:/user/auth/login
     */
    authControllerLogin: (data: ILoginRequest, params: RequestParams = {}) =>
      this.request<ILoginOkResponse, IBadRequestResponse>({
        path: `/user/auth/login`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name AuthControllerVerifyTwoFaCode
     * @summary Verify the login 2FA SMS code — resume token
     * @request POST:/user/auth/login/2fa-verify
     */
    authControllerVerifyTwoFaCode: (
      data: ITwoFaVerifyRequest,
      params: RequestParams = {}
    ) =>
      this.request<ITwoFaVerifyOkResponse, IBadRequestResponse>({
        path: `/user/auth/login/2fa-verify`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name AuthControllerGoogleLogin
     * @summary Google OAuth login — exchange code, find-or-create user, resume token
     * @request POST:/user/auth/login/google
     */
    authControllerGoogleLogin: (
      data: IGoogleLoginRequest,
      params: RequestParams = {}
    ) =>
      this.request<IGoogleLoginOkResponse, IBadRequestResponse>({
        path: `/user/auth/login/google`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name AuthControllerCheck
     * @summary Check the resume token validity (auth-only)
     * @request POST:/user/auth/check
     * @secure
     */
    authControllerCheck: (params: RequestParams = {}) =>
      this.request<
        ICheckOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/auth/check`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name AuthControllerForgotPassword
     * @summary Send the password reset email (silent for unknown email)
     * @request POST:/user/auth/password/forgot
     */
    authControllerForgotPassword: (
      data: IForgotPasswordRequest,
      params: RequestParams = {}
    ) =>
      this.request<IForgotPasswordOkResponse, IBadRequestResponse>({
        path: `/user/auth/password/forgot`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name AuthControllerResetPassword
     * @summary Reset the password with the emailed token — logout-all + resume token
     * @request POST:/user/auth/password/reset
     */
    authControllerResetPassword: (
      data: IResetPasswordRequest,
      params: RequestParams = {}
    ) =>
      this.request<IResetPasswordOkResponse, IBadRequestResponse>({
        path: `/user/auth/password/reset`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name EmailVerificationControllerVerifyEmail
     * @summary Verify email with the 4-char code
     * @request POST:/user/auth/verify-email
     * @secure
     */
    emailVerificationControllerVerifyEmail: (
      data: IVerifyEmailRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IVerifyEmailOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/auth/verify-email`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name EmailVerificationControllerResendVerifyEmailToken
     * @summary Resend the email verification code (reuses existing token)
     * @request POST:/user/auth/resend-verify-email-token
     * @secure
     */
    emailVerificationControllerResendVerifyEmailToken: (
      params: RequestParams = {}
    ) =>
      this.request<
        IResendVerifyEmailTokenOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/auth/resend-verify-email-token`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name AdminOtpControllerOtpLogin
     * @summary Admin OTP impersonation login — issues a resume token for the target user
     * @request POST:/user/admin/otp-login
     */
    adminOtpControllerOtpLogin: (
      data: IOtpLoginRequest,
      params: RequestParams = {}
    ) =>
      this.request<IOtpLoginOkResponse, IBadRequestResponse>({
        path: `/user/admin/otp-login`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserOtpControllerOtpLogin
     * @summary User OTP login — issues a resume token for the target user.
     * @request POST:/user/otp-login
     */
    userOtpControllerOtpLogin: (
      data: IOtpLoginRequest,
      params: RequestParams = {}
    ) =>
      this.request<IOtpLoginOkResponse, IBadRequestResponse>({
        path: `/user/otp-login`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name UserOtpControllerSendOtpLoginLink
     * @request POST:/user/send-otp-login-link
     * @secure
     */
    userOtpControllerSendOtpLoginLink: (
      data: ISendOtpLoginLinkRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<
        IUserGenerateLoginOtpResponseDto,
        IUnauthorizedResponse | IForbiddenResponse | IBadRequestResponse
      >({
        path: `/user/send-otp-login-link`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Logs
     * @name LogsControllerCreateLog
     * @summary Create frontend client log
     * @request POST:/user/logs
     * @secure
     */
    logsControllerCreateLog: (
      data: ICreateLogRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        ICreateLogOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/logs`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dev
     * @name ApiDevUserControllerSetIdentityStatus
     * @summary DEV: set identity verification status (skip Veriff)
     * @request POST:/user/dev/set-identity-status
     * @secure
     */
    apiDevUserControllerSetIdentityStatus: (
      data: IDevSetIdentityStatusRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IDevSetIdentityStatusOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/dev/set-identity-status`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dev
     * @name ApiDevUserControllerSetAdminVerifiedCompany
     * @summary DEV: set profile.adminVerifiedCompany=true (skip company admin gate)
     * @request POST:/user/dev/set-admin-verified-company
     * @secure
     */
    apiDevUserControllerSetAdminVerifiedCompany: (params: RequestParams = {}) =>
      this.request<
        IDevSetAdminVerifiedCompanyOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/dev/set-admin-verified-company`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dev
     * @name ApiDevUserControllerRunIdentityExpiryJob
     * @summary DEV: run identityExpiryJob batch now (expired identity documents)
     * @request POST:/user/dev/run-identity-expiry-job
     * @secure
     */
    apiDevUserControllerRunIdentityExpiryJob: (params: RequestParams = {}) =>
      this.request<
        IDevRunIdentityExpiryJobOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/dev/run-identity-expiry-job`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dev
     * @name ApiDevUserControllerErrorTrackingTest
     * @summary DEV: throw test error (verify PostHog error tracking chain)
     * @request POST:/user/dev/error-tracking-test
     * @secure
     */
    apiDevUserControllerErrorTrackingTest: (params: RequestParams = {}) =>
      this.request<
        ISuccessResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/dev/error-tracking-test`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dev
     * @name ApiDevUserControllerGetEmailVerificationCode
     * @summary DEV: read current user verify-email token
     * @request GET:/user/dev/email-verification-code
     * @secure
     */
    apiDevUserControllerGetEmailVerificationCode: (
      params: RequestParams = {}
    ) =>
      this.request<
        IDevEmailVerificationCodeOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/dev/email-verification-code`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dev
     * @name ApiDevWalletControllerAddCredit
     * @summary DEV: add fixed 50€ CREDIT to current user wallet
     * @request POST:/user/dev/add-credit
     * @secure
     */
    apiDevWalletControllerAddCredit: (params: RequestParams = {}) =>
      this.request<
        IDevAddCreditOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/dev/add-credit`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dev
     * @name ApiDevWalletControllerAddGift
     * @summary DEV: add fixed 50€ GIFT to current user wallet (drift, not in Meteor)
     * @request POST:/user/dev/add-gift
     * @secure
     */
    apiDevWalletControllerAddGift: (params: RequestParams = {}) =>
      this.request<
        IDevAddGiftOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/user/dev/add-gift`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
}
